export default __webpack_public_path__ + "static/building-xs-d213aa3287621e1482f2605d679948a8.png";